import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import filesModule from "./files/index.js";
import authModule from "./auth/index.js";
import configModule from "./config/index.js";
import boardModule from "./board/index.js";
import ticketModule from "./ticket/index.js";
import asaMeetingModule from "./asaMeeting/index.js";
import inspectionModule from "./inspection/index.js";
import inspectionCategoryModule from "./inspectionCategory/index.js";
import userModule from "./user/index.js";
import riskAssessmentModule from "./riskAssessment/index.js";
import riskAssessmentCategoryModule from "./riskAssessmentCategory/index.js";
import settingsModule from "./settings/index.js";
import surveyModule from "./survey/index.js";
import jobModule from "./job/index.js";
import operatingInstructionModule from "./operatingInstruction/index.js";
import instructionModule from "./instruction/index.js";
import instructionFolderModule from "./instruction/instructionFolder/index.js";
import managedInstructionAssignmentModule from "./managedInstructionAssignment/index.js";
import employeeModule from "./employee/index.js";
import employeeGroupModule from "./employeeGroup/index.js";
import tableStore from "../components/_utils/dataTableHelpers/tableStore/index";
import incidentReportModule from "./incidentReport/index.js";
import medkitlogModule from "./medkitlog/index.js";
import environmentalReportModule from "./environmentalReport/index.js";
import subscriptionJsModule from "./subscriptionJs/index.js";
import tariffModule from "./tariff/index.js";
import managedInstructionModule from "./managedInstruction/index.js";
import multiuserModule from "./multiuser/index.js";
import dangerousGoodsStorageLocationModule from "./dangerousGoods/storageLocations/index.js";
import dangerousGoodsListModule from "./dangerousGoods/dangerousGoodsList/index.js";
import examinationModule from "./examinations/index.js";
import examinationAssignmentModule from "./examinationsAssignment/index.js";
import instructionCategoryModule from "./operatingInstruction/instructionCategory/index.js";
import operatingInstructionLabelModule from "./operatingInstructionLabel/index.js";
import workplaceModule from "./workspace/index.js";
import employeeTagModule from "./employeeTag/index.js";
import userTagModule from "./userTag/index.js";
import employeeRoleModule from "./employeeRole/index.js";
import betriebsanweisungModule from "./betriebsanweisung/index.js";
import betriebsanweisungTemplateModule from "./betriebsanweisungTemplate/index.js";
import managedInstructionLocalModule from "./managedInstructionLocal/index.js";
import transferModule from "./transfer/index.js";
import riskAssessmentTemplateModule from "./riskAssessmentTemplate/index.js";
import reportModule from "./report/index.js";
import personioModule from "./personio/index.js";
import proofModule from "./proof/index.js";
import proofTagModule from "./proofTag/index.js";
import proofCategoryModule from "./proofCategory/index.js";

Vue.use(Vuex);

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    filesModule,
    authModule,
    configModule,
    boardModule,
    ticketModule,
    asaMeetingModule,
    inspectionModule,
    inspectionCategoryModule,
    userModule,
    riskAssessmentModule,
    settingsModule,
    surveyModule,
    jobModule,
    operatingInstructionModule,
    managedInstructionAssignmentModule,
    employeeModule,
    employeeGroupModule,
    instructionModule,
    instructionFolderModule,
    tableStore,
    incidentReportModule,
    medkitlogModule,
    environmentalReportModule,
    subscriptionJsModule,
    tariffModule,
    managedInstructionModule,
    multiuserModule,
    dangerousGoodsStorageLocationModule,
    dangerousGoodsListModule,
    examinationModule,
    instructionCategoryModule,
    operatingInstructionLabelModule,
    workplaceModule,
    employeeTagModule,
    userTagModule,
    employeeRoleModule,
    betriebsanweisungModule,
    betriebsanweisungTemplateModule,
    examinationAssignmentModule,
    riskAssessmentCategoryModule,
    managedInstructionLocalModule,
    transferModule,
    riskAssessmentTemplateModule,
    reportModule,
    personioModule,
    proofModule,
    proofTagModule,
    proofCategoryModule,
  },
});

export default store;
